import React, { PureComponent } from "react";
import classnames from "classnames";

import { withoutReservedTags } from "@formant/core/common/withoutReservedTags";
import { ITags } from "@formant/core/model/ITags";

import { authStore } from "../../stores";
import { copyToClipboard } from "./copyToClipboard";
import { IconButton } from "./IconButton";
import * as styles from "./Tags.scss";

export interface ITagsProps {
    tags: ITags;
    singleLine?: boolean;
    className?: string;
}

export class Tags extends PureComponent<ITagsProps> {
    public render() {
        if (!authStore.featureEnabled("diagnostics")) {
            return false;
        }

        const { onClickCopy } = this;
        const { singleLine, className } = this.props;

        const tags = withoutReservedTags(this.props.tags);

        const tooltip = Object.keys(tags).reduce((a, key) => {
            if (key && tags[key]) {
                if (a) {
                    a += "\n";
                }
                a += `${key}: ${tags[key]}`;
            }
            return a;
        }, "");

        const markedUpTags = Object.keys(tags).map((tag, index) => {
            return (
                <span className={styles.tag} key={`${tag}-${index}`}>
                    <span className={styles.type}>{tag}</span>
                    <span className={styles.values}>{tags[tag]}</span>
                </span>
            );
        });

        return (
            <div
                className={classnames(
                    styles.tags,
                    className,
                    singleLine && styles["single-line"],
                )}
            >
                {markedUpTags.length > 0 && (
                    <IconButton
                        icon="tags"
                        onClicked={onClickCopy}
                        data-tooltip="Copy tags to clipboard"
                    />
                )}
                <div className={styles.content} title={tooltip}>
                    {markedUpTags}
                </div>
            </div>
        );
    }

    private onClickCopy = () => {
        const tags = withoutReservedTags(this.props.tags);
        copyToClipboard(JSON.stringify(tags));
    };
}
